exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n  font-family: Lato, Roboto, Noto, Helvetica, Tahoma, Arial, \"Microsoft YaHei New\", \"Microsoft Yahei\", \"Noto Sans CJK SC\", \"Noto Sans CJK\", \"\\5FAE\\8F6F\\96C5\\9ED1\", \"\\5B8B\\4F53\", SimSun, STXihei, \"\\534E\\6587\\7EC6\\9ED1\", \"PingFang SC\", sans-serif;\n}\n.serif {\n  font-family: Baskerville, \"Lucida Bright\", \"Times New Roman\", \"Times\";\n}\n.resetButton {\n  border: none;\n  background-color: none;\n}\n.wp2-page .chevron {\n  background-color: transparent !important;\n}\nmain.wp2 {\n  background-color: #2e2e2e;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\nmain.wp2 h1 {\n  margin: 47px 0 15px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: white;\n  text-align: center;\n}\nmain.wp2 .weui-footer {\n  padding: 5px;\n}\nmain.wp2 .weui-footer a {\n  color: #b17090;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/pages/WelcomePage.less
// module id = 1370
// module chunks = 0